type ChangeValue = { change: number; value: number };

type ScenarioGrantedPoolSource = {
  unvested?: ChangeValue;
  unvestedPercentage?: ChangeValue;
};

type ScenarioGrantedPoolFigures = {
  convertedBasis: ChangeValue;
  convertedBasisPercentage: ChangeValue;
  diluted: ChangeValue;
  dilutedPercentage: ChangeValue;
  issued: ChangeValue;
  issuedPercentage: ChangeValue;
};

const ZERO: ChangeValue = { change: 0, value: 0 };

/**
 * Figures for a pool's row under "Equity Pools Granted". The granted-but-unvested reserve is
 * issued to the pool, so it counts on the issued side, but every granted share already sits in its
 * holder's diluted (and converted) figure, and the scenario diluted denominator leaves the reserve
 * out. Mirroring it into Diluted counted those shares twice and pushed the Diluted % column past
 * 100%. The cap table Details view and the fundraising Excel export both show 0 here.
 */
export const getScenarioGrantedPoolFigures = (
  pool: ScenarioGrantedPoolSource,
): ScenarioGrantedPoolFigures => ({
  issued: {
    value: pool.unvested?.value || 0,
    change: pool.unvested?.change || 0,
  },
  issuedPercentage: {
    value: pool.unvestedPercentage?.value || 0,
    change: pool.unvestedPercentage?.change || 0,
  },
  diluted: ZERO,
  dilutedPercentage: ZERO,
  convertedBasis: ZERO,
  convertedBasisPercentage: ZERO,
});
